import React from 'react';
import Cards from '../components/Home/Intro/cards.component';
import Contact from '../components/Contact/contact.component';
import Course from '../components/Home/Course/course.component';
import AnimatedNotification from '../components/animated-notification/animated-notification.component';
import Testimonial from '../components/testimonials/testimonial.component';
import CoursesNewCard from '../components/Home/Course/courses-new.component';
import HeroSection from '../components/Hero/hero-section';
import HowSection from '../components/How/how-section';
import CtaSection from '../components/Contact/section-cta';
import FooterNew from '../components/Footer/section-footer';

const Home = () => {
  return (
    <>
      {/* <AnimatedNotification /> */}
      <HeroSection />
      <CoursesNewCard />

      <HowSection />

      {/* <Testimonial /> */}
      <CtaSection />

      <FooterNew />
    </>
  );
};

export default Home;
